import { Editor as EditorRef } from "@tinymce/tinymce-react";
import { Stack } from "@mui/material";
import { useAtom } from "jotai";
import { contourValuesAtom } from "atoms";
import { convertContourValues } from "shared/utils/tts-custom-editor";
import { SSMLTag } from "shared/constants";
import ContourLineChart from "./ContourLineChart";
import MenuWrapper from "features/TTS/TTSCustomEditor/components/MenuWrapper";

interface ContourMenuProps {
  editorRef: React.RefObject<EditorRef | null>;
  onContourChange?: (value: string) => void;
}

/**
 * ContourMenu component for managing speech contour in TTS editor
 */
export default function ContourMenu({
  editorRef,
  onContourChange,
}: ContourMenuProps): JSX.Element {
  const [contourValues] = useAtom(contourValuesAtom);

  const getGraphValues = () => {
    const response: { x: number; y: number }[] = [];
    contourValues.forEach((contourValue) => {
      response.push({ x: contourValue.data.time, y: contourValue.data.value });
    });
    return response;
  };

  const handleContourUpdate = () => {
    const convertedContourValues = convertContourValues(contourValues);

    if (onContourChange) {
      onContourChange(convertedContourValues);
    }
  };

  return (
    <MenuWrapper
      id="contour-menu-wrapper"
      showDeleteButton={false}
      editorRef={editorRef}
      tagType={SSMLTag.Contour}
    >
      <Stack gap={4} mt={1}>
        <ContourLineChart
          inputData={getGraphValues()}
          onChange={handleContourUpdate}
        />
      </Stack>
    </MenuWrapper>
  );
}
